import { Link } from 'react-router-dom';
import AnimSection from '../components/AnimSection';
import { TEAM, TIMELINE } from '../data';

export default function About() {
  return (
    <div className="page-enter" style={{ paddingTop:'66px' }}>

      {/* ── PAGE HERO ─────────────────────────── */}
      <div style={{ background:'var(--page-hero-soft)', padding:'5rem clamp(1.2rem,4vw,3rem) 4rem', borderBottom:'1px solid var(--border-1)', position:'relative', overflow:'hidden' }}>
        <div className="grid-bg" style={{ position:'absolute', inset:0 }} />
        <div style={{ position:'absolute', right:'2%', top:'70%', transform:'translateY(-50%)', fontFamily:'var(--fH)', fontSize:'clamp(6rem,12vw,10rem)', color:'var(--accent-15)', letterSpacing:'4px', pointerEvents:'none' }}>ABOUT</div>
        <div className="sw" style={{ position:'relative', zIndex:1 }}>
          <div className="tag" style={{ marginBottom:'1rem' }}>Our Story</div>
          <h1 className="section-title" style={{ fontSize:'clamp(2.4rem,5vw,4rem)', marginBottom:'1rem' }}>ABOUT <span className="highlight">ELBOT</span></h1>
          <p style={{ color:'var(--mu)', maxWidth:'600px', lineHeight:1.8, fontSize:'1.05rem' }}>
            Established in 2019 and headquartered in Bawana Industrial Area, New Delhi Elbot Automation is a specialised industrial automation solutions provider delivering high-quality, reliable, and cost-effective automation services across a wide range of industries.
          </p>
        </div>
      </div>

      {/* ── WHO WE ARE ────────────────────────── */}
      <div style={{ background:'var(--w2)', padding:'6rem clamp(1.2rem,4vw,3rem)' }}>
        <div className="sw">
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'5rem', alignItems:'center' }}>
            <AnimSection>
              <div className="tag" style={{ marginBottom:'1rem' }}>Who We Are</div>
              <h2 className="section-title" style={{ marginBottom:'.5rem' }}>ENGINEERING<br /><span className="highlight">EXCELLENCE</span><br />SINCE 2019</h2>
              <div className="divider" />
              <p style={{ color:'var(--mu)', lineHeight:1.8, marginBottom:'1.5rem' }}>
                We are a service-oriented company focused on providing end-to-end automation solutions — from concept and design to commissioning and post-installation support. With strong expertise in PLC, SCADA, and control panel systems, we help industries enhance operational efficiency, reduce downtime, and optimise energy usage.
              </p>
              <p style={{ color:'var(--mu)', lineHeight:1.8, marginBottom:'2rem' }}>
                Our core strength lies in PLC & SCADA systems, along with robust panel manufacturing and seamless plant integration capabilities. Our multidisciplinary team covers electrical, software, and project management disciplines — giving every client a single, reliable partner from concept through commissioning and beyond.
              </p>
              <Link to="/contact" className="btn-primary">Start Your Project →</Link>
            </AnimSection>

            <AnimSection delay={.15}>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'1rem' }}>
                {[
                  { icon:'🏆', t:'ISO 9001 Certified', s:'Quality Management' },
                  { icon:'⚡', t:'24/7 Support',        s:'Always Available'   },
                  { icon:'🌍', t:'5 Countries',        s:'Global Presence'    },
                  { icon:'🔬', t:'18% in R&D',          s:'Continuous Innovation' },
                  { icon:'🎓', t:'15+ Engineers',       s:'Certified Experts'  },
                  { icon:'📋', t:'Fixed-Price',         s:'No Surprises'       },
                ].map((c,i) => (
                  <div key={i} className="card" style={{ padding:'1.5rem', textAlign:'center' }}>
                    <div style={{ fontSize:'1.8rem', marginBottom:'.7rem' }}>{c.icon}</div>
                    <div style={{ fontFamily:'var(--fH)', fontSize:'.95rem', letterSpacing:'1.5px', marginBottom:'.2rem' }}>{c.t}</div>
                    <div style={{ color:'var(--mu)', fontSize:'.75rem', fontFamily:'var(--fM)' }}>{c.s}</div>
                  </div>
                ))}
              </div>
            </AnimSection>
          </div>
        </div>
      </div>

      {/* ── VISION / MISSION / VALUES ─────────── */}
      <div style={{ background:'var(--w3)', padding:'6rem clamp(1.2rem,4vw,3rem)' }}>
        <div className="sw">
          <AnimSection style={{ textAlign:'center', marginBottom:'3.5rem' }}>
            <div className="tag" style={{ marginBottom:'1rem' }}>Vision & Mission</div>
            <h2 className="section-title">OUR <span className="highlight">PURPOSE</span></h2>
            <div className="divider" style={{ margin:'1rem auto 0' }} />
          </AnimSection>

          <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'1.5rem' }}>
            {[
              { icon:'🔭', t:'VISION', c:'var(--o)', bg:'var(--oL)', d:'To be the most trusted global partner for intelligent industrial automation — enabling factories that are autonomous, sustainable, and built for the next century of manufacturing.' },
              { icon:'🎯', t:'MISSION', c:'var(--o)', bg:'var(--oL)', d:'We engineer precise, reliable, and scalable automation systems that reduce waste, increase throughput, improve worker safety, and empower manufacturers to compete at the world\'s highest level.' },
              { icon:'⚖️', t:'VALUES', c:'var(--o)', bg:'var(--oL)', d:'Precision. Integrity. Innovation. Accountability. We hold ourselves to the highest engineering standards and build long-term partnerships through complete transparency and measurable results.' },
            ].map(c => (
              <AnimSection key={c.t}>
                <div className="card" style={{ padding:'2.5rem', borderTop:`3px solid ${c.c}`, height:'100%' }}>
                  <div style={{ width:'52px', height:'52px', borderRadius:'12px', background:c.bg, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'1.5rem', marginBottom:'1.2rem' }}>{c.icon}</div>
                  <h3 style={{ fontFamily:'var(--fH)', fontSize:'1.4rem', letterSpacing:'1px', color:c.c, marginBottom:'1rem' }}>{c.t}</h3>
                  <p style={{ color:'var(--mu)', lineHeight:1.8, fontSize:'.93rem' }}>{c.d}</p>
                </div>
              </AnimSection>
            ))}
          </div>
        </div>
      </div>

      {/* ── WHY CHOOSE US ─────────────────────── */}
      <div style={{ background:'var(--w2)', padding:'6rem clamp(1.2rem,4vw,3rem)' }}>
        <div className="sw">
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'5rem', alignItems:'center' }}>
            <AnimSection>
              <div className="tag" style={{ marginBottom:'1rem' }}>Why Choose Us</div>
              <h2 className="section-title" style={{ marginBottom:'.5rem' }}>THE ROADMAP TO<br /><span className="highlight">SERVICE EXCELLENCE</span></h2>
              <div className="divider" />
              <p style={{ color:'var(--mu)', lineHeight:1.8, marginBottom:'2rem' }}>
                Every project follows a meticulously structured delivery methodology — ensuring consistent quality, clear communication, and results that exceed expectations at every stage.
              </p>
              {[
                'Expertise & Experience: Deep industry knowledge on every project',
                'Tailored Solutions: Custom-designed around your unique challenges',
                'Quality Assurance: Rigorous quality control at every stage',
                'Innovative Technology: Latest platforms and techniques always applied',
              ].map((f,i) => (
                <div key={i} className="check-feature">
                  <div className="check-icon">✓</div>
                  <span style={{ color:'var(--d3)', fontSize:'.93rem', lineHeight:1.7 }}>{f}</span>
                </div>
              ))}
            </AnimSection>

            <AnimSection delay={.15}>
              <div style={{ display:'flex', flexDirection:'column', gap:'1rem' }}>
                {[
                  { pct:92, label:'Client Retention Rate'    },
                  { pct:96, label:'On-Time Delivery'         },
                  { pct:98, label:'Client Satisfaction Score' },
                  { pct:100,label:'Safety Compliance Rate'   },
                ].map((b,i) => (
                  <div key={i}>
                    <div style={{ display:'flex', justifyContent:'space-between', marginBottom:'.5rem' }}>
                      <span style={{ fontFamily:'var(--fH)', fontSize:'1rem', letterSpacing:'1px' }}>{b.label}</span>
                      <span style={{ color:'var(--o)', fontFamily:'var(--fH)', fontSize:'1rem' }}>{b.pct}%</span>
                    </div>
                    <div className="progress-bar">
                      <div className="progress-fill" style={{ width:`${b.pct}%` }} />
                    </div>
                  </div>
                ))}
              </div>
            </AnimSection>
          </div>
        </div>
      </div>

      {/* ── TEAM ─────────────────────────────── */}
      <div style={{ background:'var(--w3)', padding:'6rem clamp(1.2rem,4vw,3rem)' }}>
        <div className="sw">
          <AnimSection style={{ textAlign:'center', marginBottom:'3rem' }}>
            <div className="tag" style={{ marginBottom:'1rem' }}>Leadership</div>
            <h2 className="section-title">MEET THE <span className="highlight">TEAM</span></h2>
            <div className="divider" style={{ margin:'1rem auto 0' }} />
          </AnimSection>

          <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:'1.5rem', marginBottom:'5rem' }}>
            {TEAM.map((m,i) => (
              <AnimSection key={i} delay={i*.08}>
                <div className="card" style={{ padding:'2rem', textAlign:'center' }}>
                  <div className="icon-circle" style={{ width:'70px', height:'70px', fontSize:'2rem', margin:'0 auto 1.2rem', borderRadius:'50%' }}>{m.av}</div>
                  <h3 style={{ fontFamily:'var(--fH)', fontSize:'1.05rem', letterSpacing:'1px', marginBottom:'.3rem' }}>{m.name}</h3>
                  <div style={{ color:'var(--o)', fontSize:'.75rem', fontFamily:'var(--fM)', marginBottom:'.8rem' }}>{m.role}</div>
                  <p style={{ color:'var(--mu)', fontSize:'.83rem' }}>{m.exp}</p>
                </div>
              </AnimSection>
            ))}
          </div>

          {/* Timeline */}
          <AnimSection style={{ textAlign:'center', marginBottom:'2.5rem' }}>
            <div className="tag" style={{ marginBottom:'1rem' }}>Our Journey</div>
            <h2 className="section-title">COMPANY <span className="highlight">TIMELINE</span></h2>
            <div className="divider" style={{ margin:'1rem auto 0' }} />
          </AnimSection>

          <div style={{ maxWidth:'700px', margin:'0 auto' }}>
            {TIMELINE.map((item,i) => (
              <AnimSection key={i} delay={i*.08}>
                <div style={{ display:'flex', gap:'1.5rem', marginBottom:'2rem' }}>
                  <div style={{ display:'flex', flexDirection:'column', alignItems:'center' }}>
                    <div className="timeline-dot" />
                    {i < TIMELINE.length-1 && <div style={{ flex:1, width:'2px', background:'var(--accent-15)', marginTop:'5px' }} />}
                  </div>
                  <div style={{ paddingBottom:'1rem' }}>
                    <div style={{ display:'flex', gap:'1rem', alignItems:'baseline', marginBottom:'.35rem' }}>
                      <span style={{ fontFamily:'var(--fH)', fontSize:'1.7rem', color:'var(--o)', letterSpacing:'2px' }}>{item.y}</span>
                      <span style={{ fontFamily:'var(--fH)', fontSize:'1.05rem', letterSpacing:'2px', color:'var(--dark)' }}>{item.e}</span>
                    </div>
                    <p style={{ color:'var(--mu)', lineHeight:1.75, fontSize:'.92rem' }}>{item.d}</p>
                  </div>
                </div>
              </AnimSection>
            ))}
          </div>
        </div>
      </div>

    </div>
  );
}
